import ContainerFormSkeleton from '@/Forms/Container/FormSkeleton';

export default function FormSkeleton() {
	return <ContainerFormSkeleton />;
}
